export default __webpack_public_path__ + "static/media/blueDoor.96f12c7e.gif";